const OPTIONS = [
  { value: 'MESSAGES', label: 'Mensagens' },
  { value: 'SESSIONS', label: 'Conversas' },
]

export default function MetricToggle({ value, onChange }) {
  return (
    <div
      className="inline-flex items-center rounded-xl border p-0.5"
      style={{ borderColor: 'var(--dash-border)' }}
    >
      {OPTIONS.map((opt) => {
        const active = value === opt.value
        return (
          <button
            key={opt.value}
            type="button"
            onClick={() => onChange(opt.value)}
            className="rounded-lg px-2.5 py-1 text-[11px] font-medium transition-colors"
            style={{
              color: active ? 'var(--dash-text)' : 'var(--dash-text-muted)',
              background: active ? 'var(--dash-surface-hover)' : 'transparent',
            }}
          >
            {opt.label}
          </button>
        )
      })}
    </div>
  )
}
